<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <ValidationProvider
          name="nombre"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{ required: 'El nombre es obligatorio' }"
        >
          <base-input type="text" label="Nombre" placeholder="Nombre" v-model="correduria.nombre"></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <label>Domicilio</label>
    <div class="row">
      <div class="col-8">
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="entidad"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'La entidad es obligatoria',
              }"
            >
              <label>Entidad Federativa</label>
              <select @change="fetchCitiesByState" v-model="selectState" class="form-control">
                <option v-if="isEmptyStates" value="noStates" selected>
                  {{ noStatesText }}
                </option>
                <option v-for="option in states" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="delegacion_municipio"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'La demarcación territorial es obligatoria',
              }"
            >
              <!-- <label>Demarcación Territorial o Municipio</label>
              <select v-model="correduria.domicilio.delegacion_municipio" class="custom-select">
                <option v-for="option in options_municipios" :key="option.value">
                  {{ option.text }}
                </option>
              </select> -->

              <label>Demarcación Territorial o Municipio</label>
              <select v-model="selectCity" class="form-control">
                <option v-if="isEmptyCities" value="noCities" selected>
                  {{ noCitiesText }}
                </option>
                <option v-for="option in cities" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="calle"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'La calle es obligatoria',
              }"
            >
              <base-input
                type="text"
                label="Calle / Avenida / Vía"
                placeholder="Calle"
                v-model="correduria.domicilio.calle"
              ></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-3">
            <ValidationProvider
              name="num_exterior"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El número exterior es obligatorio',
              }"
            >
              <base-input
                type="text"
                label="Número exterior"
                placeholder="Número exterior"
                v-model="correduria.domicilio.num_exterior"
              ></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-3">
            <base-input
              type="text"
              label="Número interior"
              placeholder="Número interior"
              v-model="correduria.domicilio.num_interior"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="colonia"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'La colonia es obligatoria',
              }"
            >
              <base-input
                type="text"
                label="Colonia o Urbanización"
                placeholder="Colonia o Urbanización"
                v-model="correduria.domicilio.colonia"
              ></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- <div class="col-md-6">
            <ValidationProvider name="ciudad" rules="required" v-slot="{ errors }" :custom-messages="{
              required: 'La ciudad o población es obligatoria'
            }">
              <base-input type="text" label="Ciudad o Población" placeholder="Ciudad o Población"
                v-model="correduria.domicilio.ciudad">
              </base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
        </div>

        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="pais"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El país es obligatorio',
              }"
            >
              <base-input type="text" disabled label="País" placeholder="País" v-model="correduria.domicilio.pais"></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="codigo_postal"
              rules="required|numeric"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El código postal es obligatorio',
                numeric: 'El código postal debe ser un número',
              }"
            >
              <base-input
                type="text"
                label="Código Postal"
                placeholder="Código Postal"
                v-model="correduria.domicilio.codigo_postal"
              ></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="nombre_titular"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El Nombre del titular es requerido',
              }"
            >
              <base-input
                type="text"
                label="Nombre del titular"
                placeholder="Nombre"
                v-model="correduria.nombre_titular"
              ></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="email"
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El email del titular es requerido',
              }"
            >
              <base-input type="email" label="Email del titular" placeholder="Email" v-model="correduria.email"></base-input>
              <span class="cardErrors">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="col-4">
        <DrawGoogleMap
          @location="updateCoordinates"
          :lat="parseFloat(correduria.domicilio.lat)"
          :lng="parseFloat(correduria.domicilio.lng)"
        />
      </div>
    </div>

    <b-button type="submit" class="btn-fill float-right orange-btn">Guardar</b-button>

    <b-modal no-close-on-backdrop centered ref="staff-modal" title="" hide-footer id="modalC" size="xl">
      <ModalStaff :user="currentStaff" :corredurias_id="correduria.id" @closeModal="closeModal" />
    </b-modal>

    <div class="titulo">
      <hr />
      <label>Miembros del Staff</label>
    </div>

    <div class="row">
      <div class="col-8"></div>

      <div class="col-4" v-if="correduria.id != 0">
        <b-button
          variant="warning"
          @click="newStaff()"
          size="l"
          v-b-tooltip.hover
          title="Editar"
          class="btn-fill float-right orange-btn"
        >
          Nuevo staff
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
          <h4 class="text-center">¿Seguro que quiere eliminar al staff?</h4>
          <h5 class="text-center">Se eliminarán todos los datos.</h5>
          <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
          <b-button class="mt-3 float-right" variant="primary" @click="deleteStaff()">OK</b-button>
        </b-modal>

        <div class="text-center">
          <b-table :fields="fields" :items="correduria.staff" hover>
            <template #cell(acciones)="{ item }">
              <b-button variant="warning" @click="editStaff(item.id)" size="l" v-b-tooltip.hover title="Editar" class="editBtn">
                <b-icon-pencil />
              </b-button>

              <b-button variant="danger" @click="predeleteStaff(item.id)" size="sm" v-b-tooltip.hover title="Eliminar">
                <b-icon-trash />
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrawGoogleMap from "@/views/clients/comparecientes/DrawGoogleMap.vue";
import ModalStaff from "@/views/staff/corredurias/ModalStaff.vue";

import { StaffApi, FuncionesApi, CatEntidadesFederativasApi } from "@/api";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "Form",

  props: {
    correduria: { type: Object },
  },

  components: {
    DrawGoogleMap,
    ModalStaff,
  },

  computed: {
    ...mapState(["countries", "states", "cities", "isEmptyStates", "isEmptyCities"]),
    ...mapGetters(["getCountries", "getStatesByCountryId", "getCitiesByStateId"]),

    fields() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "email", label: "Email", class: "text-center" },
        { key: "rol", label: "Rol", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
  },

  created() {
    this.correduria.domicilio.pais = "México";
    this.getEntidades();
    // this.selectEntidad();
  },

  watch: {
    selectCountry: function (val, oldVal) {
      // this.correduria.domicilio.pais = this.selectCountry;
    },
    selectState: function (val, oldVal) {
      this.correduria.domicilio.entidad = this.selectState;
    },
    selectCity: function (val, oldVal) {
      this.correduria.domicilio.delegacion_municipio = this.selectCity;
    },
  },

  async mounted() {
    await this.fetchCountries();

    // debugger;
    await this.fetchStatesByCountry();

    if (this.correduria.domicilio.pais) {
      this.selectCountry = this.correduria.domicilio.pais;

      if (this.correduria.domicilio.pais) {
        await this.getExistCountry(this.correduria.domicilio.pais);
      }
      if (this.correduria.domicilio.entidad) {
        await this.getExistState(this.correduria.domicilio.entidad);
      }
      if (this.correduria.domicilio.delegacion_municipio) {
        await this.getExistCity(this.correduria.domicilio.delegacion_municipio);
      }
    }
  },

  data() {
    return {
      currentStaffId: null,
      currentStaff: null,
      options_entidades: [],
      options_municipios: [],

      noStatesText: "No hay estados disponibles",
      noCitiesText: "No hay ciudades disponibles",
      selectCountry: "México",
      selectState: "",
      selectCity: "",
    };
  },

  methods: {
    ...mapActions(["fetchCountries", "fetchStates", "fetchCities"]),

    async fetchStatesByCountry() {
      /**
       * Esta fx se llama solo si ya se tiene un país seleccionado
       */
      this.selectState = "";
      const pais = this.selectCountry;
      this.selectCity = "";
      // change store state cities to empty
      this.$store.commit("setCities", []);
      // Obtengo el id del país
      const paisId = await this.getIdCountry(pais);
      // obtengo el código de area del país
      const phoneCode = await this.getPhoneCode(pais);
      this.phoneKey = phoneCode;
      // this.currentCompareciente.telefonos[0].clave = phoneCode;
      // obtengo los estados del país
      await this.fetchStates(paisId);
      if (this.isEmptyStates) {
        this.selectState = "noStates";
        this.selectCity = "noCities";
      }
    },

    async fetchCitiesByState() {
      /**
       * Se llama para obtener las ciudades de un estado seleccionado
       */
      this.selectCity = "";
      const estado = this.selectState;
      const estadoId = await this.getIdState(estado);
      await this.fetchCities(estadoId);
    },

    async getIdCountry(countryName) {
      /**
       * Obtiene el id del país seleccionado
       */
      const country = this.countries.find((c) => c.name === countryName);
      return country ? country.id : null;
    },

    async getIdState(stateName) {
      /**
       * Obtiene el id del estado seleccionado
       */
      const state = this.states.find((s) => s.name === stateName);
      return state ? state.id : null;
    },

    async getPhoneCode(countryName) {
      /**
       * Obtiene el código de área del país seleccionado
       */
      const country = this.countries.find((c) => c.name === countryName);
      return country ? country.phone_code : null;
    },

    async getExistCountry(countryName) {
      /**
       * Se llama si ya se tiene un país seleccionado
       */
      const currentCountry = countryName === "Mexico" ? "México" : this.correduria.domicilio.pais;
      this.selectCountry = currentCountry;
    },

    async getExistState(stateName) {
      /**
       * Se llama si ya se tiene un estado seleccionado
       */
      const currentState = stateName;
      this.selectState = currentState;
      const paisId = await this.getIdCountry(this.selectCountry);
      await this.fetchStates(paisId);
    },

    async getExistCity(cityName) {
      /**
       * Se llama si ya se tiene una ciudad seleccionada
       */
      const currentCity = cityName;
      this.selectCity = currentCity;
      const estadoId = await this.getIdState(this.selectState);
      await this.fetchCities(estadoId);
    },

    async getEntidades() {
      const { value } = await CatEntidadesFederativasApi.list({
        page: 0,
        registersPerPage: 0,
      });
      value.forEach((element) => {
        const obj = { text: element.entidad_federativa, value: element.id };
        this.options_entidades.push(obj);
      });
      // if (this.correduria.domicilio.entidad != null) {
      this.selectEntidad();
      // }
    },

    async selectEntidad() {
      try {
        this.options_municipios = [];
        if (this.options_entidades) {
          let cat_entidades_id = this.options_entidades.find((o) => o.text === this.correduria.domicilio.entidad).value;
          console.log(cat_entidades_id);

          const { value } = await FuncionesApi.getMunicipiosDeEntidad(cat_entidades_id);

          value.forEach((element) => {
            const obj = { text: element.municipio, value: element.id };
            this.options_municipios.push(obj);
          });
        }
      } catch (error) {
        // console.log(error);
        // this.selectEntidad();
      }
    },

    updateCoordinates(coordinates) {},

    editStaff(id) {
      this.currentStaff = this.correduria.staff.find((x) => x.id == id);

      this.$refs["staff-modal"].show();
    },

    newStaff() {
      this.currentStaff = { id: 0 };
      this.$refs["staff-modal"].show();
    },

    predeleteStaff(id) {
      this.currentStaffId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    closeModal() {
      this.$refs["staff-modal"].hide();
    },

    async deleteStaff() {
      try {
        this.loading = true;

        const id = this.currentStaffId;

        await StaffApi.delete(id);

        const index = this.correduria.staff.findIndex(o => o.id == id);
        if (index !== -1) {
          this.correduria.staff.splice(index, 1);
        }

        this.$toast.success("Staff eliminado", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
        this.$refs["modal-confirm-dialog"].hide();
      }
    },
  },
};
</script>

<style>
#card {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  /* color: #9a9a9a; */
  color: #ea640b;
  font-size: 13px;
}

.titulo {
  margin-top: 7%;
}
</style>
